import { render, staticRenderFns } from "./WhatsappScheduledList.vue?vue&type=template&id=28a73bda&scoped=true&"
import script from "./WhatsappScheduledList.vue?vue&type=script&lang=js&"
export * from "./WhatsappScheduledList.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappScheduledList.vue?vue&type=style&index=0&id=28a73bda&lang=scss&scoped=true&"
import style1 from "./WhatsappScheduledList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a73bda",
  null
  
)

export default component.exports